import React, { Component } from 'react';
import { connect } from 'react-redux';
// components
import { Prompt } from 'react-router';
import { TabContent, Nav  } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { NavigationTab } from 'components/navigation';
import { FontAwesome, LoadingScreen } from 'components/ui';
// tabs
import { PlatoonTab, TeachersTab, SoldiersTab } from './tabs';
// functions
import { toast } from 'react-toastify';
import { setTitle } from 'functions/utils';
import { getPlatoon, updatePlatoon, deletePlatoon } from 'store/base/platoons/operations';
import { removeAuth, removeTeacher, createAuth } from 'store/base/staff/operations';
import { filterUpdates } from 'functions/events';

export class PlatoonPage extends Component {
  // initial state
  state = {
    platoon: {}, updates: {}, 
    loading: true, activeTab: 1,
  }

  // load the contents if we do not have any
  componentDidMount(){
    const isCamp = this.props.login.inst_id === 8;
    setTitle( isCamp ? 'Bunk' : 'Platoon' );
    this.getPlatoon();
  }

  // non-destructivly update the state
  onUpdate = ( update ) => {
    const updates = filterUpdates( this.state.platoon, { ...this.state.updates, ...update } );
    this.setState({ updates });
  }
  // toggle tabs
  toggle = activeTab => () => this.setState({ activeTab });

  // Networking
  getPlatoon = () => {
    const { match, getPlatoon } = this.props;
    this.setState({ loading: true });
    getPlatoon( match.params.id )
    .then( platoon => { this.setState({ platoon, loading: false }); console.log(platoon); })
    .catch( error => {
      toast.error( error.message );
      this.setState({ platoon: undefined }); }
    );
  }
  // save platoon
  save = ( event ) => {
    event && event.preventDefault();
    const { updates, platoon } = this.state;
    this.props.updatePlatoon( platoon.class_id, updates )
    .then( platoon => this.setState({ platoon, updates: {} }) );
  }

  delete = event => {
    event && event.preventDefault();
    const isCamp = this.props.login.inst_id === 8;
    if ( !window.confirm(`Are you sure you want to delete this ${ isCamp ? 'bunk' : 'platoon' }?`) )
      return false;

    this.props.deletePlatoon( this.state.platoon.class_id )
    .then( () => { this.setState({ platoon: undefined }) })
    .catch( e => toast.error( e.message ) );
  }

  render() {
    let { platoon, loading, updates, activeTab } = this.state;
    const isCamp = this.props.login.inst_id === 8;

    if ( platoon === undefined )
      return <Redirect to='/bm/platoons' />;

    if ( loading )
      return <LoadingScreen  Callout />

    const updated = Object.keys( this.state.updates ).length > 0;
    platoon = { ...platoon, ...updates };

    return (
      <div id='PlatoonPage'>
        <Prompt when={ updated } message="You have unsaved changes. Are you sure you want to leave?" />
        <Nav tabs>
          <NavigationTab active={activeTab === 1} onClick={this.toggle( 1 )}>
            { isCamp ? 'Bunk' : 'Platoon' } <FontAwesome icon='chalkboard-teacher'/>
          </NavigationTab>
          <NavigationTab active={activeTab === 2} onClick={this.toggle( 2 )}>
            { isCamp ? 'Counselor Accounts' : 'Teacher Accounts' } <FontAwesome icon='user-lock'/>
          </NavigationTab>
          { platoon.soldiers.length > 0 &&
            <NavigationTab active={activeTab === 3} onClick={this.toggle( 3 )}>
              { isCamp ? 'Campers' : 'Soldiers' } <FontAwesome icon='users'/>
            </NavigationTab>
          }
        </Nav>
        <TabContent activeTab={ activeTab }>

          <PlatoonTab
            tabId={ 1 }
            platoon={ platoon }
            updated={ updated }
            onSubmit={ this.save }
            onDelete={ this.delete }
            onUpdate={ this.onUpdate }
            isCamp={ isCamp } />

          <TeachersTab
            tabId={ 2 }
            platoon={ platoon }
            refresh={ this.getPlatoon }
            createAuth={ this.props.createAuth }
            removeAuth={ this.props.removeTeacher } />

          <SoldiersTab
            tabId={ 3 }
            platoon={ platoon }
            users={ platoon.soldiers } />

        </TabContent>

      </div>
    )
  }
}

const mapStateToProps = ({ login }) => ({
  login: login.current_login, 
})

const mapDispatchToProps = { 
  getPlatoon, updatePlatoon, deletePlatoon,
  removeAuth, removeTeacher, createAuth
}

export default connect( mapStateToProps, mapDispatchToProps )( PlatoonPage );



// WEBPACK FOOTER //
// ./src/pages/base-managment/platoons/PlatoonPage.jsx